import ProjectBreakdown from './ProjectBreakdown';
export default ProjectBreakdown;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/ProjectBreakdown/index.js